"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MAX_ITERATIONS = 25;
var Resizer = /** @class */ (function () {
    function Resizer() {
        this.iterations = 0;
    }
    Resizer.prototype.init = function (context, options, callback) {
        this.setPageSize(options);
        this.callbackArgs = {
            pixelDensity: window.devicePixelRatio >= 2 ? 2 : 1,
            previewPageHeight: this.previewPageHeight,
            previewPageWidth: this.previewPageWidth,
            isMobile: this.isMobile,
            fullInLandscape: this.fullInLandscape
        };
        this.callback = callback;
        this.fitTo(context);
    };
    Resizer.prototype.setPageSize = function (options) {
        this.previewPageHeight = options.height;
        this.previewPageWidth = options.width;
        this.absoluteZoom = options.absoluteZoom || false;
    };
    Resizer.prototype.fitTo = function (context) {
        this.$el = $(context);
        this.resize();
        $(window).on('resize', this.resize.bind(this));
    };
    Resizer.prototype.zoomPage = function (element, scale, x, y) {
        if (this.absoluteZoom) {
            if (!scale) {
                // new version uses translate and absolute position
                $('.pb-preview-page-zoom').css({
                    'transform': 'scale(1) translate(0, 0)'
                });
            }
            else {
                x = isNaN(x) ? this.previewPageWidth / 2 : x;
                y = isNaN(y) ? this.previewPageHeight / 2 : y;
                scale = Math.min(1 / this.transformFactor, scale);
                var targetX = this.previewPageWidth / 2 - x;
                var targetY = this.previewPageHeight / 2 - y;
                var minX = ((this.previewPageWidth * scale / 2) - (this.previewPageWidth / 2)) / scale;
                var minY = ((this.previewPageHeight * scale / 2) - (this.previewPageHeight / 2)) / scale;
                var translateX = Math.max(Math.min(targetX, minX), -minX);
                var translateY = Math.max(Math.min(targetY, minY), -minY);
                if (scale > 1.2) {
                    $('.pb-preview-page-zoom').css({
                        'transform': "scale(" + scale + ") translate(" + translateX + "px, " + translateY + "px)"
                    });
                }
            }
        }
        else {
            // old version uses transform-origin
            if (!scale) {
                $('.pb-preview-page-zoom').css({
                    'transform': 'scale(1)'
                });
            }
            else {
                x = isNaN(x) ? .5 : x;
                y = isNaN(y) ? .5 : y;
                scale = Math.min(1 / this.transformFactor, scale);
                if (scale > 1.2) {
                    $('.pb-preview-page-zoom').css({
                        'transform-origin': x * 100 + '% ' + y * 100 + '%',
                        'transform': 'scale(' + scale + ')'
                    });
                }
            }
        }
    };
    Resizer.prototype.showFullScreen = function (full) {
        this.isFullscreen = full;
        this.resize();
    };
    Resizer.prototype.resize = function (iterate) {
        var _this = this;
        if (!this.$el) {
            return;
        }
        this.windowInnerWidth = this.$el.parent().width();
        this.isMobile = !window.matchMedia('(min-width: 1024px)').matches || this.windowInnerWidth < 1024;
        this.fullInLandscape = this.isMobile && $(window).height() >= 1024;
        var resizer = this, innerWidth = $('.pb-preview .pb-preview-inner').width() || 0, innerHeight = innerWidth;
        if (this.isFullscreen) {
            innerWidth = $('.pb-preview .pb-swipe').width() || 0;
            innerHeight = $('.pb-preview .pb-swipe').height() || 0;
        }
        // calculate globally for callback:
        var factorY = innerHeight / resizer.previewPageHeight, factorX = innerWidth / resizer.previewPageWidth, factor = Math.min(factorX, factorY);
        factor = Math.min(factor, 1);
        factor = Math.round(factor * 1000) / 1000;
        // repeat resizing if element height or width is 0
        if (factor === 0 && this.iterations < MAX_ITERATIONS) {
            if (iterate) {
                this.iterations++;
            }
            setTimeout(function () { _this.resize(true); });
            return;
        }
        this.iterations = 0;
        var previewPageWidth = Math.floor(resizer.previewPageWidth * factor), previewPageHeight = Math.floor(resizer.previewPageHeight * factor);
        resizer.transformFactor = factor;
        resizer.calculatedPreviewPageWidth = previewPageWidth;
        resizer.calculatedPreviewPageHeight = previewPageHeight;
        // calculate each page:
        $('.pb-preview-page').each(function () {
            var height = parseInt($(this).attr('data-height'), 10) || resizer.previewPageHeight, width = parseInt($(this).attr('data-width'), 10) || resizer.previewPageWidth;
            var factorY = innerWidth / width, factorX = innerHeight / height, factor = Math.min(factorX, factorY);
            // factor = Math.max(factor, .5);
            factor = Math.min(factor, 1);
            factor = Math.round(factor * 1000) / 1000;
            var previewPageWidth = Math.floor(width * factor), previewPageHeight = Math.floor(height * factor), previewPageTop = (innerHeight - previewPageHeight) / 2, previewPageLeft = (innerWidth - previewPageWidth) / 2;
            $(this).find('.pb-preview-page-transform').css({
                height: height + "px",
                width: width + "px",
                transform: "scale3D(" + factor + ", " + factor + ", 1)"
            });
            $(this).css({
                height: previewPageHeight + "px",
                width: previewPageWidth + "px",
                top: previewPageTop + "px",
                left: previewPageLeft + "px"
            });
            $('.pb-preview-pager').css({
                top: previewPageTop + previewPageHeight + "px"
            });
        });
        this.callback(Object.assign(this.callbackArgs, {
            previewPageHeight: resizer.calculatedPreviewPageHeight,
            previewPageWidth: resizer.calculatedPreviewPageWidth,
            isMobile: this.isMobile,
            fullInLandscape: this.fullInLandscape
        }));
    };
    return Resizer;
}());
exports.Resizer = Resizer;
exports.default = angular.module('pb.resizer', [])
    .service('resizer', Resizer);
